<template>
  <div class="mb-2">
    <label>
      <span v-if="label">{{ label }}</span>
    </label>
    <woot-thumbnail
      v-if="src"
      size="80px"
      :src="src"
      :username="usernameAvatar"
    />
    <div class="mt-2">
      <woot-button
        color-scheme="secondary"
        variant="hollow"
        size="tiny"
        type="button"
        class-names="border border-solid border-orange-400"
        @click="triggerSelectFile"
      >
        {{ $t('COMMON.CHOOSE_FILE') }}
      </woot-button>
      <span class="text-xs">{{ displayAvatarFileName }}</span>
    </div>
    <div v-if="src && deleteAvatar" class="avatar-delete-btn">
      <woot-button
        color-scheme="alert"
        variant="hollow"
        size="tiny"
        type="button"
        @click="onAvatarDelete"
      >
        {{ $t('PROFILE_SETTINGS.DELETE_AVATAR') }}
      </woot-button>
    </div>
    <label>
      <input
        id="file"
        ref="file"
        class="hidden"
        type="file"
        accept="image/png, image/jpeg, image/gif"
        @change="handleImageUpload"
      />
      <slot />
    </label>
  </div>
</template>

<script>
export default {
  name: 'WootAvatarUploader',
  props: {
    label: {
      type: String,
      default: '',
    },
    src: {
      type: String,
      default: '',
    },
    usernameAvatar: {
      type: String,
      default: '',
    },
    deleteAvatar: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      avatarFileName: '',
    };
  },
  computed: {
    displayAvatarFileName() {
      return this.avatarFileName || this.$t('COMMON.NO_FILE_CHOSEN');
    },
  },
  watch: {},
  methods: {
    handleImageUpload(event) {
      const [file] = event.target.files;
      if (file) {
        this.avatarFileName = file.name;
        this.$emit('change', {
          file,
          url: file ? URL.createObjectURL(file) : null,
        });
      }
    },
    onAvatarDelete() {
      this.$refs.file.value = null;
      this.avatarFileName = null;
      this.$emit('onAvatarDelete');
    },
    triggerSelectFile() {
      this.$refs.file.click();
    },
  },
};
</script>

<style lang="scss" scoped>
.avatar-delete-btn {
  margin-top: var(--space-smaller);
  margin-bottom: var(--space-smaller);
}
</style>
